import type { SiteControllerSettingTllInput, TllMasterObjectInput } from "@/lib/gql/__generated__/graphql";

import type { SiteControllerSettingTllFormModel } from "../../../type";

type Props = {
	viewModel: SiteControllerSettingTllFormModel["ViewModel"];
};
export const viewModelToInput = ({ viewModel }: Props) => {
	const { hotelID, tll } = viewModel;

	const input: SiteControllerSettingTllInput = {
		hotelID,
		tll: {
			defaultPlan: tll.defaultPlan?.value,
			rooms: tll.rooms.value.map((room) => {
				return {
					chillnnRoomID: room.chillnnRoomID?.value,
					tllRoomID: room.tllRoomID?.value,
				};
			}),
			tllID: tll.tllID.value,
		} satisfies TllMasterObjectInput,
	} satisfies SiteControllerSettingTllInput;

	return input;
};
